import React from 'react';

function BlockKL() {
  const ictData = [
    {
      slNo: 1,
      indicator: 'Did the factory use computer/s during FY 2019-20?',
      response: '2'
    },
    {
      slNo: 2,
      indicator: 'Did the factory use the internet during FY 2019-20?',
      response: ''
    },
    {
      slNo: 3,
      indicator: 'Did the factory have a website as on the date of survey?',
      response: ''
    },
    {
      slNo: 4,
      indicator: 'Did the factory receive orders via the internet during FY 2019-20?',
      response: ''
    },
    {
      slNo: 5,
      indicator: 'Did the factory place orders for business purpose via the internet during FY 2019-20?',
      response: ''
    },
    {
      slNo: 6,
      indicator: 'Did the factory connect to the internet either by a. Narrowband or b. Fixed broadband or c. Mobile broadband during FY 2019-20?',
      response: ''
    },
    {
      slNo: 7,
      indicator: 'Does the factory have a local area network (LAN) as on the date of survey?',
      response: ''
    }
  ];

  const energyData = [
    {
      slNo: 1,
      indicator: 'Electric Saving:',
      response: ''
    },
    {
      slNo: 2,
      indicator: 'Coal Saving:',
      response: ''
    },
    {
      slNo: 3,
      indicator: 'Oil Saving:',
      response: ''
    },
    {
      slNo: 4,
      indicator: 'Gas Saving:',
      response: ''
    }
  ];

  return (
    <>
      <style>
        {`
          .block-kl-header {
            background-color: #e3f2fd;
            padding: 15px 20px;
            border-bottom: 2px solid #1976d2;
            margin-bottom: 20px;
          }
          .page-title {
            color: #1976d2;
            font-size: 24px;
            font-weight: bold;
            margin: 0;
          }
          .reference-numbers {
            color: #333;
            font-size: 14px;
            font-weight: 500;
            margin: 0;
          }
          .blocks-container {
            display: flex;
            gap: 20px;
            margin-bottom: 20px;
          }
          .block-section {
            flex: 1;
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 6px;
            overflow: hidden;
          }
          .block-title {
            background-color: #f8f9fa;
            padding: 12px 15px;
            border-bottom: 2px solid #1976d2;
            font-weight: 600;
            color: #1976d2;
            font-size: 16px;
          }
          .block-subtitle {
            background-color: #f8f9fa;
            padding: 8px 15px;
            border-bottom: 1px solid #dee2e6;
            font-size: 12px;
            color: #666;
            font-style: italic;
          }
          .table th {
            background-color: #e3f2fd;
            color: #1976d2;
            font-weight: 600;
            font-size: 12px;
            text-align: center;
            vertical-align: middle;
            padding: 10px 8px;
            border: 1px solid #dee2e6;
          }
          .table td {
            font-size: 12px;
            text-align: center;
            vertical-align: middle;
            padding: 8px 8px;
            border: 1px solid #dee2e6;
          }
          .table td:first-child {
            text-align: center;
            font-weight: 600;
            width: 50px;
          }
          .table td:nth-child(2) {
            text-align: left;
            font-weight: 500;
            min-width: 200px;
          }
          .table td:nth-child(3) {
            text-align: center;
            font-weight: 500;
            width: 80px;
            background-color: #f8f9fa;
          }
          .response-input {
            width: 60px;
            text-align: center;
            border: 1px solid #ddd;
            border-radius: 3px;
            padding: 4px;
            font-size: 12px;
          }
          @media (max-width: 768px) {
            .blocks-container {
              flex-direction: column;
            }
          }
        `}
      </style>
      <div className="container-fluid py-3">
        {/* Header Section */}
        <div className="block-kl-header">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h1 className="page-title">Block K and L</h1>
            </div>
            <div className="col-md-6 text-end">
              <p className="reference-numbers">DSL No : 404936</p>
              <p className="reference-numbers">PSL No : 31186</p>
            </div>
          </div>
        </div>

        {/* Blocks Container */}
        <div className="blocks-container">
          {/* Block K: ICT Usage */}
          <div className="block-section">
            <div className="block-title">Block K: Information & Communication Technology (ICT) Usage</div>
            <div className="table-responsive">
              <table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th>SI No.</th>
                    <th>ICT Indicator</th>
                    <th>Yes-1/No-2</th>
                  </tr>
                </thead>
                <tbody>
                  {ictData.map((row, index) => (
                    <tr key={index}>
                      <td>{row.slNo}</td>
                      <td>{row.indicator}</td>
                      <td>
                        {row.response ? (
                          <span style={{ fontWeight: '600' }}>{row.response}</span>
                        ) : (
                          <input
                            type="text"
                            className="response-input"
                            placeholder="1/2"
                          />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Block L: Energy Conservation */}
          <div className="block-section">
            <div className="block-title">Block L: Energy Conservation (EC) Measures</div>
            <div className="block-subtitle">
              Have any measures been taken during last financial year with regard to:-
            </div>
            <div className="table-responsive">
              <table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th>SI No.</th>
                    <th>EC Indicator</th>
                    <th>Yes-1/No-2</th>
                  </tr>
                </thead>
                <tbody>
                  {energyData.map((row, index) => (
                    <tr key={index}>
                      <td>{row.slNo}</td>
                      <td>{row.indicator}</td>
                      <td>
                        <input
                          type="text"
                          className="response-input"
                          placeholder="1/2"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="row mt-4">
          <div className="col-12">
            <hr />
          </div>
          <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
            <button type="button" className="btn btn_orange mx-1">
              Print  
              <i className="fa fa-print ms-1"></i>
            </button>
            <button type="button" className="btn btn_orange mx-1">
              Save
            </button>
            <button type="reset" className="btn btn_orange mx-1">
              Reset
            </button>
            <button type="button" className="btn btn_orange mx-1">
              Cancel
            </button>
          </div>
          <div className="col-md-4 text-center text-md-end">
            <button type="button" className="btn btn_orange mx-1">
              Back 
              <i className="fa fa-angle-left ms-1"></i>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlockKL; 